import React from 'react'
import { Router, Link } from 'react-static'
import { hot } from 'react-hot-loader'
//
import Routes from 'react-static-routes'

import ReactGA from 'react-ga'

import Header from './components/Header'

import './app.scss'

ReactGA.initialize('UA-31096467-1')

if (typeof window !== 'undefined') {
  ReactGA.pageview(window.location.pathname)
}

const App = () => (
  <Router>
    <React.Fragment>
      <Header />

      <div className="main">
        <Routes />
      </div>
    </React.Fragment>
  </Router>
)

export default hot(module)(App)



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/App.js